import PropTypes from "prop-types"
import styled from "styled-components"
import { brandTertiaryTheme } from "../../../theme"

const FeatureCardInnerImageWrapper = styled.div`
  display: flex;
  background-color: ${brandTertiaryTheme};
  padding: 10px;
  border-radius: 100%;
  height: 100%;
  width: 100%;
    ${({ theme }) => theme.se`
    width: 100%;
    flex-direction: column;
    align-items: center;
    order: 1;
    justify-content: center;
  `}

    ${({ theme }) => theme.tablet`
  `}

    ${({ theme }) => theme.desktop`


  `}

  > img {
    margin: 0;
  }
`

FeatureCardInnerImageWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

export default FeatureCardInnerImageWrapper
